module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl-detail",
    class: {
      admin: this.$root.authorizedUser
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n      Loading...\n    ")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.PLDetails) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "top-images"
  }, [(_vm.PLDetails.bannerphoto) ? [_c('img', {
    attrs: {
      "src": 'https://img.productionlocations.com/' + _vm.PLDetails.bannerphoto
    }
  })] : [_c('img', {
    attrs: {
      "src": 'https://img.productionlocations.com/' + _vm.PLDetails.featuredphoto
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "print-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('h3', [_vm._v("323.874.0404")]), _vm._v(" "), _c('h4', [_c('A', {
    attrs: {
      "href": "mailto:scout@productionlocations.com"
    }
  }, [_vm._v("scout@productionlocations.com")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('section', {
    staticClass: "page-header"
  }, [_c('section', {
    staticClass: "pl-columns",
    class: {
      mobileshow: _vm.mobileShowDetails
    }
  }, [_c('h1', [_vm._v("PL" + _vm._s(_vm.PLDetails.plnumber) + " "), (_vm.PLDetails.status !== 'publish') ? _c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.PLDetails.status))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "locationinfo"
  }, [(_vm.PLDetails.permitarea) ? [_vm._v("Permit Area: "), _c('b', [_vm._v("LA")]), _c('br')] : _vm._e(), _vm._v("\n            City: "), _c('b', [_vm._v(_vm._s(_vm.PLDetails.property_city))]), _c('br'), _vm._v("\n            Zip: "), _c('b', [_vm._v(_vm._s(_vm.PLDetails.property_zip))])], 2), _vm._v(" "), (!_vm.mobileShowDetails) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.mobileShowDetails = true
      }
    }
  }, [_vm._v("Show Details "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.PLDetails.categories), function(category) {
    return _c('div', {
      staticClass: "column",
      class: category.name
    }, [_c('h4', [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('p', [_vm._l((category.tags), function(tag, key, index) {
      return [_vm._v(_vm._s(tag.name)), (index != (Object.keys(category.tags).length - 1)) ? [_vm._v(", ")] : _vm._e()]
    })], 2)])
  })], 2)]), _vm._v(" "), (this.$root.authorizedUser) ? _c('section', {
    staticClass: "admin-info",
    class: {
      mobileshow: _vm.mobileShowDetails
    }
  }, [_c('section', {
    staticClass: "admin-inner"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', [(_vm.PLDetails.property_buildingname) ? [_c('small', [_vm._v(_vm._s(_vm.PLDetails.property_buildingname))]), _c('br')] : _vm._e(), _vm._v("\n            " + _vm._s(_vm.PLDetails.property_address) + "\n          ")], 2), _vm._v(" "), _c('div', {
    staticClass: "plfield"
  }, [_vm._v("\n              " + _vm._s(_vm.PLDetails.property_city) + ", " + _vm._s(_vm.PLDetails.property_state) + " " + _vm._s(_vm.PLDetails.property_zip) + "\n            ")]), _vm._v(" "), (_vm.PLDetails.renees) ? _c('span', {
    staticClass: "renees"
  }, [_vm._v("Renees")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "plfield"
  }, [_c('label', [_vm._v("Last Used")]), _vm._v(" "), (_vm.PLDetails.last_used) ? _c('span', {
    staticClass: "difficultyfield"
  }, [_vm._v(_vm._s(_vm.PLDetails.last_used))]) : _c('span', {
    staticClass: "difficultyfield"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "plfield"
  }, [_c('label', [_vm._v("Difficulty / Frequency")]), _vm._v(" "), _c('span', {
    staticClass: "difficultyfield"
  }, [_c('i', {
    class: _vm.PLDetails.property_difficulty_frequency
  }), _vm._v(" " + _vm._s(_vm.PLDetails.property_difficulty_frequency))])]), _vm._v(" "), _c('div', {
    staticClass: "plfield"
  }, [_c('label', [_vm._v("Difficulty / Price")]), _vm._v(" "), _c('span', {
    staticClass: "difficultyfield"
  }, [_c('i', {
    class: _vm.PLDetails.property_difficulty_price
  }), _vm._v(" " + _vm._s(_vm.PLDetails.property_difficulty_price))])]), _vm._v(" "), _c('div', {
    staticClass: "plfield"
  }, [_c('label', [_vm._v("Difficulty / Usability")]), _vm._v(" "), _c('span', {
    staticClass: "difficultyfield"
  }, [_c('i', {
    class: _vm.PLDetails.property_difficulty_usability
  }), _vm._v(" " + _vm._s(_vm.PLDetails.property_difficulty_usability))])]), _vm._v(" "), _c('a', {
    staticClass: "filemakerbutton",
    class: {
      renees: _vm.PLDetails.renees
    },
    attrs: {
      "href": 'fmp://10.0.1.3/PL%20Database%20Interface.fmp12?script=Quick%20Find%20from%20Website&param=%3D%3DPL' + _vm.PLDetails.plnumber + '&$PLnumber=%3D%3DPL' + _vm.PLDetails.plnumber
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("folder_open")]), _vm._v(" Open in FileMaker")]), _vm._v(" "), _c('a', {
    staticClass: "editbutton",
    class: {
      renees: _vm.PLDetails.renees
    },
    attrs: {
      "href": 'https://admin.productionlocations.com/pls/view/' + _vm.PLDetails.id
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("edit")]), _vm._v(" Edit")])]), _vm._v(" "), _c('Div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "subheader"
  }, [_vm._v("Contacts")]), _vm._v(" "), _c('div', {
    staticClass: "contactswrapper"
  }, _vm._l((_vm.PLDetails.contacts), function(contact) {
    return _c('div', {
      staticClass: "contactbox"
    }, _vm._l((contact), function(fieldval, fieldname) {
      return _c('div', {
        staticClass: "plfield"
      }, [_c('label', [_vm._v(_vm._s(fieldname))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(fieldval))])])
    }))
  }))]), _vm._v(" "), _c('Div', {
    staticClass: "column"
  }, [(_vm.PLDetails.property_sqft) ? _c('div', {
    staticClass: "subheader"
  }, [_vm._v("Sq Feet")]) : _vm._e(), _vm._v(" "), (_vm.PLDetails.property_sqft) ? _c('div', {
    staticClass: "plfield"
  }, [_vm._v(_vm._s(_vm.PLDetails.property_sqft))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notes-wrapper"
  }, [(_vm.PLDetails.property_notes) ? _c('div', [_c('div', {
    staticClass: "subheader"
  }, [_vm._v("Additional Notes")]), _vm._v(" "), _c('div', {
    staticClass: "plfield",
    domProps: {
      "innerHTML": _vm._s(_vm.PLDetails.property_notes)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.PLDetails.property_hoanotes) ? _c('div', [_c('div', {
    staticClass: "subheader"
  }, [_vm._v("HOA & Management")]), _vm._v(" "), _c('div', {
    staticClass: "plfield",
    domProps: {
      "innerHTML": _vm._s(_vm.PLDetails.property_hoanotes)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.PLDetails.property_feenotes) ? _c('div', [_c('div', {
    staticClass: "subheader"
  }, [_vm._v("Rates & Fees")]), _vm._v(" "), _c('div', {
    staticClass: "plfield",
    domProps: {
      "innerHTML": _vm._s(_vm.PLDetails.property_feenotes)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.PLDetails.property_usenotes) ? _c('div', [_c('div', {
    staticClass: "subheader"
  }, [_vm._v("Use & Access")]), _vm._v(" "), _c('div', {
    staticClass: "plfield",
    domProps: {
      "innerHTML": _vm._s(_vm.PLDetails.property_usenotes)
    }
  })]) : _vm._e()])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control-panel"
  }, [_c('div', {
    staticClass: "control-panel-inner"
  }, [_c('div', {
    staticClass: "size-selector"
  }, [_c('div', {
    staticClass: "toggle-switch",
    class: {
      switched: _vm.fullsizeview
    },
    on: {
      "click": function($event) {
        _vm.toggleFullSizeView()
      }
    }
  }, [_c('div', {
    staticClass: "option",
    class: {
      highlighted: !_vm.fullsizeview
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("view_module")]), _c('span', [_vm._v(" Grid")])]), _vm._v(" "), _c('div', {
    staticClass: "option",
    class: {
      highlighted: _vm.fullsizeview
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("view_stream")]), _c('span', [_vm._v(" Full")])]), _vm._v(" "), _c('div', {
    staticClass: "highlight"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('a', {
    attrs: {
      "href": 'https://api.productionlocations.com/pdf/' + _vm.PLDetails.plnumber,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("insert_drive_file")]), _vm._v(" Download .pdf")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ({
        el: '.photos',
        offset: -50
      }),
      expression: "{el: '.photos', offset: -50}"
    }],
    on: {
      "click": function($event) {
        _vm.toggleZipSelect()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("folder")]), _vm._v(" Download .zip")])])])]), _vm._v(" "), _c('div', {
    staticClass: "photo-filter"
  }, [_vm._v("\n      Show photos of: "), _c('span', {
    class: {
      selected: !_vm.photofilter
    },
    on: {
      "click": function($event) {
        _vm.photofilter = false
      }
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.photoTags), function(tag) {
    return _c('span', {
      class: {
        selected: _vm.photofilter == tag.id
      },
      on: {
        "click": function($event) {
          _vm.photofilter = tag.id
        }
      }
    }, [_vm._v(_vm._s(tag.name))])
  })], 2), _vm._v(" "), _c('BackToTop'), _vm._v(" "), (!_vm.fullsizeview) ? _c('div', {
    staticClass: "photos grid"
  }, [_c('div', {
    directives: [{
      name: "packery",
      rawName: "v-packery",
      value: ({
        itemSelector: ".photo",
        percentPosition: true,
        columnWidth: ".masonry-sizer"
      }),
      expression: "{itemSelector: \".photo\", percentPosition: true, columnWidth: \".masonry-sizer\"}"
    }],
    ref: "packery",
    staticClass: "photos-masonry",
    attrs: {
      "transition": ""
    }
  }, [_c('div', {
    staticClass: "masonry-sizer"
  }), _vm._v(" "), _vm._l((_vm.filteredPhotos), function(photo, photoIndex) {
    return [_c('div', {
      directives: [{
        name: "packery-item",
        rawName: "v-packery-item"
      }],
      staticClass: "photo",
      class: {
        enlarge: _vm.enlargedPhoto == photoIndex
      }
    }, [_c('div', {
      staticClass: "photo-inner"
    }, [(_vm.zipselect) ? _c('div', {
      staticClass: "zipcheckbox",
      class: {
        selected: photo.selected
      },
      on: {
        "click": function($event) {
          photo.selected = !photo.selected
        }
      }
    }, [(photo.selected) ? _c('i', {
      staticClass: "material-icons selected"
    }, [_vm._v("check_box")]) : _c('i', {
      staticClass: "unselected material-icons"
    }, [_vm._v("check_box_outline_blank")])]) : [(!_vm.photosInPullSheet.includes(photo.filename)) ? _c('div', {
      staticClass: "addtopullsheet",
      on: {
        "click": function($event) {
          _vm.addToPullSheet(photo.filename)
        }
      }
    }, [_vm._v("Add")]) : _c('div', {
      staticClass: "addtopullsheet added"
    }, [_vm._v("Added")])], _vm._v(" "), _c('img', {
      staticClass: "grid",
      attrs: {
        "src": 'https://img.productionlocations.com/' + photo.filename
      },
      on: {
        "click": function($event) {
          _vm.photoClick(photoIndex)
        }
      }
    })], 2)]), _vm._v(_vm._s(' ') + "\n      ")]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.fullsizeview) ? _c('div', {
    staticClass: "photos full"
  }, [_c('div', {
    staticClass: "masonry-sizer"
  }), _vm._v(" "), _vm._l((_vm.filteredPhotos), function(photo, photoIndex) {
    return [_c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      staticClass: "photo",
      class: {
        enlarge: _vm.enlargedPhoto == photoIndex
      }
    }, [_c('div', {
      staticClass: "photo-inner"
    }, [(!_vm.photosInPullSheet.includes(photo.filename)) ? _c('div', {
      staticClass: "addtopullsheet",
      on: {
        "click": function($event) {
          _vm.addToPullSheet(photo.filename)
        }
      }
    }, [_vm._v("Add")]) : _c('div', {
      staticClass: "addtopullsheet added"
    }, [_vm._v("Added")]), _vm._v(" "), _c('img', {
      staticClass: "full",
      attrs: {
        "src": 'https://img.productionlocations.com/' + photo.filename
      }
    })])]), _vm._v(_vm._s(' ') + "\n      ")]
  })], 2) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideup"
    }
  }, [(_vm.zipselect) ? _c('div', {
    staticClass: "zipselect-footer"
  }, [_c('h2', [_vm._v("Select photos to include in your download")]), _vm._v(" "), _c('div', {
    staticClass: "selectall"
  }, [_vm._v("Select: "), _c('span', {
    on: {
      "click": function($event) {
        _vm.zipSelectAll(true)
      }
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.zipSelectAll(false)
      }
    }
  }, [_vm._v("None")])]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(_vm.selectedPhotoCount) + " photo"), (_vm.selectedPhotoCount != 1) ? [_vm._v("s")] : _vm._e(), _vm._v(" selected")], 2), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [(_vm.zipDownloading) ? [_c('button', {
    attrs: {
      "disabled": "true"
    }
  }, [_vm._v("Preparing...")])] : [_c('button', {
    on: {
      "click": function($event) {
        _vm.zipselect = false
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("cancel")]), _vm._v(" Cancel")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "https://api.productionlocations.com/zip",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        _vm.zipDownload()
      }
    }
  }, [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")]), _vm._v(" Download")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPhotoString),
      expression: "selectedPhotoString"
    }],
    attrs: {
      "type": "hidden",
      "name": "selectedphotos"
    },
    domProps: {
      "value": (_vm.selectedPhotoString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedPhotoString = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PLDetails.plnumber),
      expression: "PLDetails.plnumber"
    }],
    attrs: {
      "type": "hidden",
      "name": "plnumber"
    },
    domProps: {
      "value": (_vm.PLDetails.plnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.PLDetails, "plnumber", $event.target.value)
      }
    }
  })])]], 2)]) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e720f1a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PLDetail.vue
// module id = 196
// module chunks = 1